import { FetchParams } from "../hooks/utility-hoks/useFetchWithToken";

type GetLiveDataResponseBody = {
  currentOccupancy: number; // last seen value
  maxOccupancyToday: number; // last seen value
  occupancyDiffLastHour: number; // diff last hour (starting at "lastUpdated")
  lastUpdated: string | null; // timestamp of last received data
};

export type GetLiveDataResponse = {
  statusCode: number;
  body: GetLiveDataResponseBody;
};

export const getLiveData = (locationName: string): FetchParams => {
  let url = "https://api.rmcounting.no/v3/data/live";
  url += `?name=${encodeURIComponent(locationName)}`;
  return { url };
};
